import React, {useContext, useState} from "react";
import '../../../styles/component/employee-details/employee-details-tabs.scss';
import BankDetailsTab from "./tabs/BankDetailsTab";
import ExperienceTab from "./tabs/ExperienceTab";
import PersonalInfoTab from "./tabs/PersonalInfoTab";
import EducationTab from "./tabs/EducationTab";
import FamilyTab from "./tabs/FamilyTab";
import {IFileState} from "../types/employee-details.types";
import {IEmployeeDetail} from "../../../domains/models/employee";
import EmployeeDocuments from "./tabs/EmployeeDocumentsTab";
import AssetsTab from "./tabs/AssetsTab";
import UserLoginContext from "../../../context/userLoginContext";

interface EmployeeDetailTabsProps {
    employeeData: any;
    profileState?: IFileState;
    getInitials?: (e: IEmployeeDetail | null) => string;
}

const EmployeeDetailTabs = ({employeeData, profileState, getInitials}: EmployeeDetailTabsProps) => {
    const [activeTab, setActiveTab] = useState<string | undefined>("personalInfo");
    const {user} = useContext(UserLoginContext);

    const employeeDetailTabs = [
        {
            title: "Personal Info",
            key: 'personalInfo',
            children: <PersonalInfoTab employeeData={employeeData}/>
        },
        {
            title: "Education",
            key: 'education',
            children: <EducationTab employeeData={employeeData}/>
        },
        {
            title: "Experience",
            key: 'experience',
            children: <ExperienceTab employeeData={employeeData}/>
        },
        {
            title: "Family",
            key: 'family',
            children: <FamilyTab
                employeeData={employeeData}
                profileState={profileState}
                getInitials={getInitials}
            />
        },
        {
            title: "Bank Details",
            key: 'bankDetails',
            children: <BankDetailsTab employeeData={employeeData}/>
        },
        {
            title: "Documents",
            key: 'documents',
            children: <EmployeeDocuments/>
        },
        {
            ...user.isAdmin && {
                title: "Assets",
                key: 'assets',
                children: <AssetsTab employeeData={employeeData}/>
            }
        },
    ];


    const activeTabData = employeeDetailTabs.find(tab => tab.key === activeTab);

    return (
        <div className="employee-details-tabs-wrapper">

            {/* Tab Buttons */}
            <div className="employee-details-tabs">
                {employeeDetailTabs.map((item) => (
                    <button
                        key={item.key}
                        className={`employee-detail-tab-button ${
                            activeTab === item.key ? "active" : ""
                        }`}
                        onClick={() => setActiveTab(item.key)}
                    >
                        {item.title}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div className="employee-details-tab-content">
                {activeTabData?.children}
            </div>

        </div>
    );
};

export default EmployeeDetailTabs;
